export default (theme) => ({
  root: {
    backgroundColor: 'transparent',
    border: 'none',
  },
  drawer: {
    width: 215,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    zIndex: '999 !important',
    backgroundColor: '#6A1A5F',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    borderBottomRightRadius: '15px',
    borderTopRightRadius: '15px',
  },
  drawerOpen: {
    width: 215,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(8),
  },
  logoWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '63px',
    flexShrink: 0,
  },
  logoLink: {
    fontSize: 0,
  },
  logoImage: {
    cursor: 'pointer',
  },
  logoDivider: {
    marginBottom: theme.spacing(2),
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  profile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content',
  },
  avatar: {
    width: '100px',
    height: '100px',
  },
  nameText: {
    marginTop: theme.spacing(2),
  },
  bioText: {},
  profileDivider: {
    marginBottom: `${theme.spacing(2)} !important`,
    marginTop: `${theme.spacing(2)} !important`,
  },
  listItem: {
    cursor: 'pointer',
    height: theme.spacing(5),
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
      boxShadow: `inset 4px 0 0 0 ${theme.palette.primary.dark}`,
      borderRadius: '4px',
      height: theme.spacing(5),
      paddingLeft: theme.spacing(2),
      '& $listItemText': {
        display: 'block',
        fontWeight: '500 !important',
        color: 'black !important',
      },
      '& $listItemIcon': {
        marginRight: 0,
        color: `${theme.palette.common.main} !important`,
        fill: `${theme.palette.common.main} !important`,
      },
    },
    '& + &': {
      marginTop: theme.spacing(1),
    },
  },
  activeListItem: {
    boxShadow: `inset 4px 0 0 0 ${theme.palette.primary.main}`,
    borderRadius: '4px',
    backgroundColor: theme.palette.primary.light,
    height: theme.spacing(5),
    '& $listItemText': {
      fill: theme.palette.text.primary,
      color: `${theme.palette.text.primary} !important`,
      fontWeight: 500,
    },
    '& $listItemIcon': {
      color: `${theme.palette.common.main} !important`,
      fill: theme.palette.common.main,
    },
  },
  listItemIcon: {
    marginRight: 0,
    color: `${theme.palette.common.white} !important`,
    fill: theme.palette.common.white,
  },
  listItemText: {
    display: 'block',
    fontWeight: '500 !important',
    color: `${theme.palette.text.white} !important`,
  },
  listItemTextHide: {
    display: 'none',
  },

  listDivider: {
    marginBottom: `${theme.spacing(2)} !important`,
    marginTop: `${theme.spacing(2)} !important`,
  },

  logoImg: {
    marginTop: theme.spacing(1),
    filter: 'drop-shadow(0px 5px 5px #000)',
  },
  footerMenu: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'flex-end',
  },
});
